<template>
  <div data-test="side-by-side">
    <div class="grid grid-cols-2 gap-2">
      <div v-for="col in columns" :key="col.label" class="min-w-0">
        <div class="mb-1 text-[11px] font-medium uppercase tracking-wider text-gray-500">{{ col.label }}</div>
        <p
          :class="['whitespace-pre-wrap break-words rounded border px-2 py-1 leading-6', col.box]"
          :data-test="`side-${col.key}`"
        ><span v-if="!col.parts.length" class="italic text-gray-400">(nothing)</span><span v-for="(p, n) in col.parts" :key="n" :class="PART[p.op]">{{ p.text }}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import { sides } from './templateChanges';

// Removed words are struck through on the left, added words highlighted on the right; unchanged text is plain.
const PART = {
  ' ': 'text-gray-700',
  '-': 'rounded-sm bg-red-tint text-gray-900 line-through',
  '+': 'rounded-sm bg-secondary-100 text-gray-900',
};

export default {
  name: 'HermesSideBySide',
  props: {
    // A word diff: [{ op: ' ' | '-' | '+', text }].
    parts: { type: Array, required: true },
    beforeLabel: { type: String, default: 'Before' },
    afterLabel: { type: String, default: 'After' },
  },
  data() {
    return { PART };
  },
  computed: {
    columns() {
      const { before, after } = sides(this.parts);
      const blank = (list) => !list.some((p) => p.text.trim());
      return [
        { key: 'before', label: this.beforeLabel, parts: blank(before) ? [] : before, box: 'border-gray-200 bg-gray-50' },
        { key: 'after', label: this.afterLabel, parts: blank(after) ? [] : after, box: 'border-gray-200 bg-white' },
      ];
    },
  },
};
</script>
